"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stubCache = void 0;
function stubCache() {
    return {
        async get(_key) {
            return undefined;
        },
        async set(_key, _value, _options) {
            return false;
        },
        async del(_key) {
            return 0;
        },
        async getOrCreate(_key, creator, _options) {
            return creator();
        },
        async miss(_key, _value, _options) {
            return false;
        },
        async flushAll() {
            // no-op
        },
    };
}
exports.stubCache = stubCache;
//# sourceMappingURL=stub-cache.js.map